export default function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}



//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/~/d3-shape/src/pointRadial.js
// module id = 243
// module chunks = 0